import { useMemo } from 'react';
import { useBootstrapData } from '@/data/user/bootstrap-data';

export interface CatalogMenuItem {
  id: string;
  label: string;
  route: string;
}

export const useCatalogMenu = () => {
  const { bootstrap } = useBootstrapData();

  return useMemo(() => {
    const bootstrapCourseTypes = bootstrap?.taxonomy?.course_types ?? [];
    const bootstrapKnowledgeAreas = bootstrap?.taxonomy?.knowledge_areas ?? [];

    const courseTypes: CatalogMenuItem[] = bootstrapCourseTypes.map(
      (item, idx) => ({
        id: `course_types_${item.type}_${idx}`,
        label: item.label,
        route: `/cursos?course_types=${item.type}`,
      })
    );

    const knowledgeAreas: CatalogMenuItem[] = bootstrapKnowledgeAreas.map(
      (item, idx) => ({
        id: `knowledge_areas_${item.id}_${idx}`,
        label: item.description_pt_br,
        route: `/cursos?knowledge_areas=${item.id}`,
      })
    );

    return { courseTypes, knowledgeAreas };
  }, [bootstrap]);
};
